export default "__VITE_ASSET__DL1rRSoO__"